// extracted by mini-css-extract-plugin
module.exports = {"ErrorBlock":"index-module--ErrorBlock--3aWJ1","WarningMessage":"index-module--WarningMessage--1d7RW"};